// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const UnorderedListOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 20 20","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M3.54 13.33a1.88 1.88 0 110 3.75 1.88 1.88 0 010-3.75zm0 1.25a.63.63 0 100 1.25.63.63 0 000-1.25zm14.63 0c.09 0 .16.08.16.17v.92c0 .09-.07.16-.16.16H6.83a.17.17 0 01-.16-.16v-.92c0-.1.07-.17.16-.17h11.34zM3.54 7.92a1.87 1.87 0 110 3.75 1.87 1.87 0 010-3.75zm0 1.25a.62.62 0 100 1.25.62.62 0 000-1.25zm14.63 0c.09 0 .16.07.16.16v.92c0 .1-.07.17-.16.17H6.83a.17.17 0 01-.16-.17v-.92c0-.09.07-.16.16-.16h11.34zM3.54 2.5a1.88 1.88 0 110 3.75 1.88 1.88 0 010-3.75zm0 1.25a.62.62 0 100 1.25.62.62 0 000-1.25zm14.63 0c.09 0 .16.07.16.17v.91c0 .1-.07.17-.16.17H6.83a.17.17 0 01-.16-.17v-.91c0-.1.07-.17.16-.17h11.34z","fill":"currentColor"}}]},"name":"UnorderedList","theme":"outlined"};

const UnorderedListOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={UnorderedListOutlinedSvg} />;
  UnorderedListOutlined.displayName = 'UnorderedListOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(UnorderedListOutlined);
